import Button, { ButtonProps } from "shared/Button/Button";
import React from "react";

export interface ButtonPrimaryProps extends ButtonProps {}

const ButtonPrimary: React.FC<ButtonPrimaryProps> = ({
  className = "",
  ...args
}) => {
  return (
    <Button
      className={`button-primary disabled:bg-opacity-70 bg-kirmizi hover:bg-black text-white uppercase ${className}`}
      {...args}
    />
  );
};

export default ButtonPrimary;
